/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CursorClickIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Cursor Click',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M10.47559,18.9668c-.18945,0-.37793-.03809-.55859-.11328-.55762-.23047-.91699-.77051-.91699-1.37305v-8.10156c0-.60059.3584-1.13965.91309-1.37207.55371-.23145,1.18848-.11035,1.61621.31055l5.52344,5.41895c.43359.4248.56543,1.06348.33496,1.625-.22949.56152-.76953.9248-1.37695.9248h-2.2793c-.21777,0-.42188.09668-.55957.26465l-1.58496,1.92871c-.32227.32422-.7168.4873-1.11133.4873ZM10.47852,9.3877l.02148,8.09766,1.5127-1.88672c.42285-.51562,1.0498-.8125,1.71875-.8125h2.2793l-5.53223-5.39844ZM10.5,4.69629V1.75c0-.41406-.33594-.75-.75-.75s-.75.33594-.75.75v2.94629c0,.41406.33594.75.75.75s.75-.33594.75-.75ZM17.5,8.75c0-.41406-.33594-.75-.75-.75h-2c-.41406,0-.75.33594-.75.75s.33594.75.75.75h2c.41406,0,.75-.33594.75-.75ZM6.58984,8.75c0-.41406-.33594-.75-.75-.75h-3.08984c-.41406,0-.75.33594-.75.75s.33594.75.75.75h3.08984c.41406,0,.75-.33594.75-.75ZM13.18848,6.37207l2.04199-2.04199c.29297-.29297.29297-.76758,0-1.06055s-.76758-.29297-1.06055,0l-2.04199,2.04199c-.29297.29297-.29297.76758,0,1.06055.14648.14648.33789.21973.53027.21973s.38379-.07324.53027-.21973ZM5.33008,14.23047l2.0791-2.0791c.29297-.29297.29297-.76758,0-1.06055s-.76758-.29297-1.06055,0l-2.0791,2.0791c-.29297.29297-.29297.76758,0,1.06055.14648.14648.33789.21973.53027.21973s.38379-.07324.53027-.21973ZM7.48535,6.48535c.29297-.29297.29297-.76758,0-1.06055l-2.15527-2.15527c-.29297-.29297-.76758-.29297-1.06055,0s-.29297.76758,0,1.06055l2.15527,2.15527c.14648.14648.33789.21973.53027.21973s.38379-.07324.53027-.21973Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
